import Cookies from 'js-cookie'
import { COOKIE_EXP_7D, COOKIE_SUBSCRIPTION_MODAL_CLOSED } from 'src/constants/cookies'

export function setSubscriptionModalClosedCookie() {
  Cookies.set(COOKIE_SUBSCRIPTION_MODAL_CLOSED, 'true', { expires: COOKIE_EXP_7D })
}

export function getSubscriptionModalClosedCookie() {
  return Boolean(Cookies.get(COOKIE_SUBSCRIPTION_MODAL_CLOSED))
}
